export default "__VITE_ASSET__jNFL_1qT__"